import { Datagrid, DateField, List, TextField } from 'react-admin';

export const RolesList = (props) => (
    <List {...props}>
        <Datagrid>
            <TextField source="id" label='user_id'/>
            <TextField source="role" />
            <TextField source="object" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
            <TextField source="user.name" label='name' />
            <TextField source="user.username" label='username' />
        </Datagrid>
    </List>
);
